// D:\my-website\src\components\Navbar.js

import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom'; // 导入 Link 和 NavLink 组件
import { useTranslation } from 'react-i18next'; // 导入国际化钩子

// Navbar 组件现在只接收 logoUrl 和 companyName props
function Navbar({ logoUrl, companyName }) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false); // 用于控制移动端菜单的展开/折叠

  return (
    <nav className="bg-gray-800 text-white p-4 shadow-lg rounded-b-lg">
      <div className="container mx-auto flex flex-col items-start"> {/* 修改为 flex-col 和 items-start */}
        {/* 第一排：Logo 和公司名称 - 靠左对齐 */}
        <Link to="/" className="flex items-center space-x-3 text-xl font-bold text-white hover:text-gray-300 transition duration-300 mb-4 md:mb-0"> {/* 将 text-2xl 缩小为 text-xl */}
          {logoUrl && (
            <img src={logoUrl} alt="Company Logo" className="h-10 w-auto rounded-full" onError={(e) => e.target.src = 'https://placehold.co/40x40/cccccc/333333?text=Logo'}/>
          )}
          <span>{companyName || t('company_name')}</span> {/* 使用国际化公司名称作为 fallback */}
        </Link>

        {/* 移动端菜单按钮 - 保持在第一排右侧，但只在小屏幕显示 */}
        <div className="absolute top-4 right-4 md:hidden"> {/* 绝对定位到右上角 */}
          <button onClick={() => setIsOpen(!isOpen)} className="text-white focus:outline-none focus:ring-2 focus:ring-blue-500 rounded-md p-2">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              {isOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* 第二排：桌面端导航链接 - 在大屏幕上显示为一行，在小屏幕上隐藏 */}
        <div className="hidden md:flex space-x-6 w-full justify-center"> {/* 将 justify-start 修改为 justify-center */}
          <NavLink
            to="/"
            className={({ isActive }) =>
              `text-2xl font-medium hover:text-blue-400 transition duration-300 ${isActive ? 'text-blue-400 border-b-2 border-blue-400' : 'text-white'}`
            }
          >
            {t('welcome_message')}
          </NavLink>
          <NavLink
            to="/business" // 业务与展望
            className={({ isActive }) =>
              `text-2xl font-medium hover:text-blue-400 transition duration-300 ${isActive ? 'text-blue-400 border-b-2 border-blue-400' : 'text-white'}`
            }
          >
            {t('business_outlook')}
          </NavLink>
          <NavLink
            to="/industry" // 行业动态
            className={({ isActive }) =>
              `text-2xl font-medium hover:text-blue-400 transition duration-300 ${isActive ? 'text-blue-400 border-b-2 border-blue-400' : 'text-white'}`
            }
          >
            {t('industry_dynamics')}
          </NavLink>
          <NavLink
            to="/about" // 关于我们 - 放到联系我们前面
            className={({ isActive }) =>
              `text-2xl font-medium hover:text-blue-400 transition duration-300 ${isActive ? 'text-blue-400 border-b-2 border-blue-400' : 'text-white'}`
            }
          >
            {t('about_us')}
          </NavLink>
          <NavLink
            to="/contact" // 联系我们
            className={({ isActive }) =>
              `text-2xl font-medium hover:text-blue-400 transition duration-300 ${isActive ? 'text-blue-400 border-b-2 border-blue-400' : 'text-white'}`
            }
          >
            {t('contact_us')}
          </NavLink>
          <NavLink
            to="/admin"
            className={({ isActive }) =>
              `text-2xl font-medium hover:text-blue-400 transition duration-300 ${isActive ? 'text-blue-400 border-b-2 border-blue-400' : 'text-white'}`
            }
          >
            {t('admin_backend')}
          </NavLink>
        </div>
      </div>

      {/* 移动端下拉菜单 - 保持在小屏幕上显示 */}
      {isOpen && (
        <div className="md:hidden mt-4 space-y-2 bg-gray-700 p-4 rounded-md">
          <NavLink
            to="/"
            onClick={() => setIsOpen(false)} // 点击后关闭菜单
            className={({ isActive }) =>
              `block px-3 py-2 rounded-md text-lg font-medium hover:bg-gray-600 ${isActive ? 'bg-gray-600 text-blue-400' : 'text-white'}`
            }
          >
            {t('welcome_message')}
          </NavLink>
          <NavLink
            to="/business"
            onClick={() => setIsOpen(false)}
            className={({ isActive }) =>
              `block px-3 py-2 rounded-md text-lg font-medium hover:bg-gray-600 ${isActive ? 'bg-gray-600 text-blue-400' : 'text-white'}`
            }
          >
            {t('business_outlook')}
          </NavLink>
          <NavLink
            to="/industry"
            onClick={() => setIsOpen(false)}
            className={({ isActive }) =>
              `block px-3 py-2 rounded-md text-lg font-medium hover:bg-gray-600 ${isActive ? 'bg-gray-600 text-blue-400' : 'text-white'}`
            }
          >
            {t('industry_dynamics')}
          </NavLink>
          <NavLink
            to="/about"
            onClick={() => setIsOpen(false)}
            className={({ isActive }) =>
              `block px-3 py-2 rounded-md text-lg font-medium hover:bg-gray-600 ${isActive ? 'bg-gray-600 text-blue-400' : 'text-white'}`
            }
          >
            {t('about_us')}
          </NavLink>
          <NavLink
            to="/contact"
            onClick={() => setIsOpen(false)}
            className={({ isActive }) =>
              `block px-3 py-2 rounded-md text-lg font-medium hover:bg-gray-600 ${isActive ? 'bg-gray-600 text-blue-400' : 'text-white'}`
            }
          >
            {t('contact_us')}
          </NavLink>
          <NavLink
            to="/admin"
            onClick={() => setIsOpen(false)}
            className={({ isActive }) =>
              `block px-3 py-2 rounded-md text-base font-medium hover:bg-gray-600 ${isActive ? 'bg-gray-600 text-blue-400' : 'text-white'}`
            }
          >
            {t('admin_backend')}
          </NavLink>
        </div>
      )}
    </nav>
  );
}

export default Navbar;
